export const MOBILE_SCREEN_WIDTH = 768
